import PostsApi from '../api/PostsApi';
import {CreatePostPayload} from '../models/Posts/Post';
import {ProjectFilter} from '../models/Projects/Project';

class PostsRepository {
  private postsApi = new PostsApi();

  public async getPosts(
    organizationId: string,
    page: number,
    pageSize: number,
    search?: string,
    filter?: ProjectFilter,
  ) {
    return this.postsApi.getPosts(
      organizationId,
      page,
      pageSize,
      search,
      filter,
    );
  }

  public async createPost(organizationId: string, payload: CreatePostPayload) {
    return this.postsApi.createPost(organizationId, payload);
  }
}

export default PostsRepository;
